import { Component, OnInit } from '@angular/core';
import { MediaCategoryService } from '../../services/media-category.service';
import { MediaCategory } from '../../models/media-category.model';

@Component({
  selector: 'app-section-media-category',
  templateUrl: './section-media-category.component.html',
  styleUrls: ['./section-media-category.component.css']
})

export class SectionMediaCategoryComponent implements OnInit {

  mediaCategories: MediaCategory[] = [];
  constructor(private mediaCategoryService: MediaCategoryService,) { }
  ngOnInit(): void {
    this.mediaCategoryService.getAllByParent().subscribe(data => {
      this.mediaCategories = data;
    })
  }

}
